import { cdmFieldTail, stripCdmPrefix } from "./ColumnMappingCanvas/utils";

export const sanitizeDisplayValue = (value) => {
    if (!value || typeof value !== "string") return "";
    let result = /^CDM_/i.test(value) ? cdmFieldTail(stripCdmPrefix(value)) : value;
    result = result.replace(/^CLB_/i, "");
    return result;
};

export const toFieldDisplayLabel = (fieldId, mschFields, displayName) => {
    if (displayName) return sanitizeDisplayValue(displayName);
    const field = mschFields?.find((f) => f.id === fieldId);
    return sanitizeDisplayValue(field?.name || fieldId);
};

export const toEntityDisplayLabel = (entity) => entity?.entity_name || "";

export const toSourceColumnLabel = (column) => sanitizeDisplayValue(column);
